import { Component } from "react";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import AdminDrawer from "../../../common_components/admin_module_drawer";
import Footer from "../../../common_components/Footer";
import Pagination from "../../../utils/pagination";
import { toastError, toastSuccess } from "../../../utils/constants";
import {
    getCampaignList_action,
    sendIntimation_action,
    getCampaignRecipients_action,
} from "../../../actions/admin_module_action/feature_intimation_action/feature_intimation_action";

const RECORDS_PER_PAGE = 10;

class FeatureIntimationList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading:        false,
            campaignList:     [],
            statusFilter:     '',
            subjectFilter:    '',
            appNoFilter:      '',
            companyFilter:    '',
            currentPage:      1,
            loginAccesslist:  [],
            exhibitionID:     sessionStorage.getItem('sessionExhibitionID') || '',
            userID:           '',
            // detail modal
            showDetail:       false,
            detailCampaign:   null,
            detailRecipients: [],
            detailPage:       1,
            detailTab:        'content',
            sendingID:        null,
            resendingID:      null,
            // resend confirm modal
            showResendConfirm: false,
            resendCampaign:    null,
        };
        this._pollTimer           = null;
        this.getCampaignList      = this.getCampaignList.bind(this);
        this.handleSearch         = this.handleSearch.bind(this);
        this.handleClear          = this.handleClear.bind(this);
        this.handleCreate         = this.handleCreate.bind(this);
        this.handleSend           = this.handleSend.bind(this);
        this.handleResend         = this.handleResend.bind(this);
        this.confirmResend        = this.confirmResend.bind(this);
        this.closeResendConfirm   = this.closeResendConfirm.bind(this);
        this.handleViewDetail     = this.handleViewDetail.bind(this);
        this.setCurrentPage       = this.setCurrentPage.bind(this);
        this.getWriteAccess       = this.getWriteAccess.bind(this);
        this.managePoll           = this.managePoll.bind(this);
    }

    componentDidMount() {
        const loginData = JSON.parse(sessionStorage.getItem('loginDataSS') || '{}');
        this.setState({
            loginAccesslist: loginData.loginAccesslist || [],
            userID: loginData.UserID || '',
        }, () => this.getCampaignList());
    }

    componentWillUnmount() {
        if (this._pollTimer) clearInterval(this._pollTimer);
    }

    managePoll(list) {
        const hasInProgress = list.some(r =>
            r.Status !== 'Sent' && r.SentCount > 0 && r.SentCount < r.RecipientCount
        );
        if (hasInProgress && !this._pollTimer) {
            this._pollTimer = setInterval(() => {
                const { statusFilter, subjectFilter, exhibitionID, userID } = this.state;
                this.props.getCampaignList_action(exhibitionID || null, userID || null, statusFilter || null, subjectFilter || null)
                    .then(data => {
                        if (data && data.error !== 1) {
                            const updated = data.data || [];
                            this.setState({ campaignList: updated });
                            this.managePoll(updated);
                        }
                    })
                    .catch(() => {});
            }, 5000);
        } else if (!hasInProgress && this._pollTimer) {
            clearInterval(this._pollTimer);
            this._pollTimer = null;
        }
    }

    getWriteAccess() {
        const moduleAccess = this.state.loginAccesslist.find(item => item.ModuleID == '105');
        return moduleAccess ? moduleAccess.WriteAccess : false;
    }

    getCampaignList() {
        const { exhibitionID, userID, statusFilter, subjectFilter } = this.state;
        this.setState({ isLoading: true });
        this.props.getCampaignList_action(exhibitionID || null, userID || null, statusFilter || null, subjectFilter || null)
            .then(data => {
                this.setState({ isLoading: false });
                if (data && data.error !== 1) {
                    const list = data.data || [];
                    this.setState({ campaignList: list, currentPage: 1 });
                    this.managePoll(list);
                } else {
                    toastError(data && data.msg ? data.msg : 'Failed to load campaigns.');
                }
            })
            .catch(() => this.setState({ isLoading: false }));
    }

    handleSearch() { this.getCampaignList(); }

    handleClear() {
        this.setState({
            statusFilter:  '',
            subjectFilter: '',
            appNoFilter:   '',
            companyFilter: '',
        }, () => this.getCampaignList());
    }

    // Application No / Company Name are filtered on the loaded list
    getFilteredList() {
        const { campaignList, appNoFilter, companyFilter } = this.state;
        const appNo   = appNoFilter.trim().toLowerCase();
        const company = companyFilter.trim().toLowerCase();
        if (!appNo && !company) return campaignList;
        return campaignList.filter(row => {
            const rowAppNo   = (row.ExhRegistrationNo || '').toString().toLowerCase();
            const rowCompany = (row.CompanyName || '').toString().toLowerCase();
            return (!appNo   || rowAppNo.includes(appNo))
                && (!company || rowCompany.includes(company));
        });
    }

    handleCreate() {
        this.props.navigate('/featureIntimationAU', { state: { is_add: true } });
    }

    handleSend(campaign) {
        if (campaign.Status === 'Sent') {
            toastError('This campaign has already been sent.');
            return;
        }
        this.setState({ sendingID: campaign.FeaIntimationID, isLoading: true });
        this.props.sendIntimation_action({
            CampaignID:   campaign.FeaIntimationID,
            ExhibitionID: this.state.exhibitionID,
        }).then(data => {
            this.setState({ sendingID: null, isLoading: false });
            if (data && data.error !== 1) {
                toastSuccess(data.msg || 'Emails queued for sending.');
                this.getCampaignList();
            } else {
                toastError(data && data.msg ? data.msg : 'Failed to send intimation.');
            }
        }).catch(() => this.setState({ sendingID: null, isLoading: false }));
    }

    handleResend(campaign) {
        if (!(campaign.RecipientCount || 0)) {
            toastError('No recipients found for this campaign.');
            return;
        }
        this.setState({ showResendConfirm: true, resendCampaign: campaign });
    }

    closeResendConfirm() {
        this.setState({ showResendConfirm: false, resendCampaign: null });
    }

    confirmResend() {
        const campaign = this.state.resendCampaign;
        if (!campaign) return;

        this.setState({
            showResendConfirm: false,
            resendCampaign:    null,
            resendingID:       campaign.FeaIntimationID,
            isLoading:         true,
        });
        this.props.sendIntimation_action({
            CampaignID:   campaign.FeaIntimationID,
            ExhibitionID: this.state.exhibitionID,
            Resend:       true,
        }).then(data => {
            this.setState({ resendingID: null, isLoading: false });
            if (data && data.error !== 1) {
                toastSuccess(data.msg || 'Emails queued for resending.');
                this.getCampaignList();
            } else {
                toastError(data && data.msg ? data.msg : 'Failed to resend intimation.');
            }
        }).catch(() => this.setState({ resendingID: null, isLoading: false }));
    }

    handleViewDetail(campaign) {
        this.setState({ isLoading: true });
        this.props.getCampaignRecipients_action(campaign.FeaIntimationID)
            .then(data => {
                this.setState({ isLoading: false });
                if (data && data.error !== 1) {
                    this.setState({
                        showDetail:       true,
                        detailCampaign:   campaign,
                        detailRecipients: data.data || [],
                        detailPage:       1,
                        detailTab:        'content',
                    });
                } else {
                    toastError('Failed to load recipient details.');
                }
            })
            .catch(() => this.setState({ isLoading: false }));
    }

    setCurrentPage(page) { this.setState({ currentPage: page }); }

    getStatusBadge(status) {
        const map = { Saved: 'secondary', Sent: 'success' };
        return <span className={`badge bg-${map[status] || 'secondary'}`}>{status}</span>;
    }

    render() {
        const {
            isLoading, statusFilter, subjectFilter, appNoFilter, companyFilter, currentPage,
            showDetail, detailCampaign, detailRecipients, detailPage, detailTab,
            sendingID, resendingID, showResendConfirm, resendCampaign,
        } = this.state;

        const DETAIL_PER_PAGE = 15;
        const detailTotal     = detailRecipients.length;
        const detailLast      = detailPage * DETAIL_PER_PAGE;
        const detailFirst     = detailLast - DETAIL_PER_PAGE;
        const detailRows      = detailRecipients.slice(detailFirst, detailLast);
        const detailPages     = Math.ceil(detailTotal / DETAIL_PER_PAGE);
        const sentCount       = detailCampaign ? (detailCampaign.SentCount || 0) : 0;
        const totalCount      = detailCampaign ? (detailCampaign.RecipientCount || 0) : 0;

        const filteredList = this.getFilteredList();
        const indexOfLast  = currentPage * RECORDS_PER_PAGE;
        const indexOfFirst = indexOfLast - RECORDS_PER_PAGE;
        const currentRows  = filteredList.slice(indexOfFirst, indexOfLast);
        const nPages       = Math.ceil(filteredList.length / RECORDS_PER_PAGE);

        return (
            <>
                <ToastContainer />
                {isLoading ? <Loader /> : null}
                <HeaderWithLogo />
                <div className="app-content with-dr-container">
                    <AdminDrawer />
                    <div className="breadcrumb-scroll-fixed">
                        <h6 className="mb-0 p-2 text-white">Notification</h6>
                    </div>
                    <div className="admin-top-space p-2">

                        {/* Filter / Search Row */}
                        <div className="row m-0 mb-2">
                            <div className="col-md-3 mb-2">
                                <label className="mb-1">Subject</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search by subject"
                                    value={subjectFilter}
                                    onChange={e => this.setState({ subjectFilter: e.target.value })}
                                />
                            </div>
                            <div className="col-md-2 mb-2">
                                <label className="mb-1">Application No</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search by application no"
                                    value={appNoFilter}
                                    onChange={e => this.setState({ appNoFilter: e.target.value, currentPage: 1 })}
                                />
                            </div>
                            <div className="col-md-3 mb-2">
                                <label className="mb-1">Company Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search by company name"
                                    value={companyFilter}
                                    onChange={e => this.setState({ companyFilter: e.target.value, currentPage: 1 })}
                                />
                            </div>
                            <div className="col-md-2 mb-2">
                                <label className="mb-1">Status</label>
                                <select
                                    className="form-control"
                                    value={statusFilter}
                                    onChange={e => this.setState({ statusFilter: e.target.value })}
                                >
                                    <option value="">All</option>
                                    <option value="Saved">Saved</option>
                                    <option value="Sent">Sent</option>
                                </select>
                            </div>
                            <div className="col-md-12 mb-2 d-flex align-items-end gap-2">
                                <button className="btn btn-aqua" onClick={this.handleSearch}>Search</button>
                                <button className="btn btn-gray"  onClick={this.handleClear}>Clear</button>
                                <button className="btn btn-aqua ms-auto" onClick={this.handleCreate}>
                                    + Create New
                                </button>
                            </div>
                        </div>

                        <div className="mb-1">
                            <small className="text-muted">Total Records: {filteredList.length}</small>
                        </div>

                        <div className="table-responsive">
                            <table className="table table-bordered sticky-table text-nowrap">
                                <thead className="table-light">
                                    <tr>
                                        <th>Sr No.</th>
                                        <th>Application No</th>
                                        <th>Company Name</th>
                                        <th>Subject</th>
                                        <th>Template</th>
                                        <th>Sent / Total</th>
                                        <th>Status</th>
                                        <th>Created At</th>
                                        <th>Details</th>
                                        <th>Send</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentRows.length > 0 ? currentRows.map((row, i) => (
                                        <tr key={row.FeaIntimationID}>
                                            <td>{indexOfFirst + i + 1}</td>
                                            <td>{row.ExhRegistrationNo || '-'}</td>
                                            <td>{row.CompanyName || '-'}</td>
                                            <td>{row.Subject}</td>
                                            <td>{row.TemplateName || '-'}</td>
                                            <td>
                                                <span className={row.SentCount > 0 ? 'text-success fw-semibold' : ''}>
                                                    {row.SentCount || 0}
                                                </span>
                                                <span className="text-muted"> / {row.RecipientCount || 0}</span>
                                            </td>
                                            <td>{this.getStatusBadge(row.Status)}</td>
                                            <td>{row.CreatedDate ? new Date(row.CreatedDate).toLocaleDateString('en-IN') : '-'}</td>
                                            <td className="text-center">
                                                <i
                                                    className="fa fa-eye grid-icon"
                                                    aria-hidden="true"
                                                    title="View recipient status"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => this.handleViewDetail(row)}
                                                />
                                            </td>
                                            <td>
                                                {(() => {
                                                    const isSent       = row.Status === 'Sent';
                                                    const isRequesting = sendingID === row.FeaIntimationID;
                                                    const isResending  = resendingID === row.FeaIntimationID;
                                                    const inProgress   = !isSent && row.SentCount > 0 && row.SentCount < row.RecipientCount;
                                                    const label        = isSent ? 'Sent' : (isRequesting || inProgress) ? 'Sending…' : 'Send';
                                                    const canResend    = isSent || row.SentCount > 0;
                                                    return (
                                                        <div className="d-flex gap-1">
                                                            <button
                                                                className="btn btn-aqua btn-sm"
                                                                onClick={() => this.handleSend(row)}
                                                                disabled={isSent || isRequesting || isResending || inProgress}
                                                            >
                                                                {label}
                                                            </button>
                                                            {canResend && (
                                                                <button
                                                                    className="btn btn-gray btn-sm"
                                                                    title="Resend to all recipients of this campaign"
                                                                    onClick={() => this.handleResend(row)}
                                                                    disabled={isRequesting || isResending || inProgress}
                                                                >
                                                                    {isResending ? 'Resending…' : 'Resend'}
                                                                </button>
                                                            )}
                                                        </div>
                                                    );
                                                })()}
                                            </td>
                                        </tr>
                                    )) : (
                                        <tr>
                                            <td colSpan="10" className="text-center">No records found</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        <Pagination
                            nPages={nPages}
                            currentPage={currentPage}
                            setCurrentPage={this.setCurrentPage}
                        />
                    </div>
                </div>

                {/* ── Recipient Detail Modal ── */}
                {showDetail && (
                    <div style={{
                        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                        backgroundColor: 'rgba(0,0,0,0.65)', zIndex: 99999,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                    }}>
                        <div style={{
                            background: '#fff', borderRadius: 8,
                            width: '90%', maxWidth: 900, maxHeight: '88vh',
                            display: 'flex', flexDirection: 'column', overflow: 'hidden',
                        }}>
                            {/* Header */}
                            <div className="p-3 d-flex justify-content-between align-items-center" style={{ background: '#3dbca7', flexShrink: 0 }}>
                                <div>
                                    <h5 className="text-white mb-0" style={{ fontSize: 15 }}>
                                        Recipient Status — {detailCampaign.Subject}
                                    </h5>
                                    <small className="text-white" style={{ opacity: 0.85 }}>
                                        Sent: {sentCount} &nbsp;|&nbsp; Total: {totalCount} &nbsp;|&nbsp; Failed: {totalCount - sentCount}
                                    </small>
                                </div>
                                <button type="button" className="btn-close btn-close-white" onClick={() => this.setState({ showDetail: false })} />
                            </div>

                            {/* Tabs */}
                            <div className="px-2 pt-2 d-flex gap-1" style={{ borderBottom: '1px solid #dee2e6', flexShrink: 0 }}>
                                <button
                                    className={`btn btn-sm ${detailTab === 'content' ? 'btn-aqua' : 'btn-gray'}`}
                                    onClick={() => this.setState({ detailTab: 'content' })}
                                >
                                    Email Content
                                </button>
                                <button
                                    className={`btn btn-sm ${detailTab === 'recipients' ? 'btn-aqua' : 'btn-gray'}`}
                                    onClick={() => this.setState({ detailTab: 'recipients' })}
                                >
                                    Recipients ({detailTotal})
                                </button>
                            </div>

                            {/* Email content preview */}
                            {detailTab === 'content' && (
                                <div style={{ flex: 1, overflow: 'auto', background: '#f6f6f6' }} className="p-2">
                                    {detailCampaign.HtmlContent ? (
                                        <iframe
                                            title="Email content preview"
                                            sandbox=""
                                            srcDoc={detailCampaign.HtmlContent}
                                            style={{
                                                width: '100%', height: '100%', minHeight: 380,
                                                border: '1px solid #dee2e6', borderRadius: 4, background: '#fff',
                                            }}
                                        />
                                    ) : (
                                        <div className="text-center text-muted py-4">No content available for this template.</div>
                                    )}
                                </div>
                            )}

                            {/* Table */}
                            {detailTab === 'recipients' && (
                            <div style={{ flex: 1, overflow: 'auto' }}>
                                <table className="table table-bordered table-sm mb-0" style={{ fontSize: 13 }}>
                                    <thead className="table-light" style={{ position: 'sticky', top: 0 }}>
                                        <tr>
                                            <th style={{ width: 48 }}>Sr.No</th>
                                            <th>Application No</th>
                                            <th>Company Name</th>
                                            <th>Email</th>
                                            <th style={{ width: 90 }}>Type</th>
                                            <th style={{ width: 80 }}>Status</th>
                                            <th>Error</th>
                                            <th style={{ width: 110 }}>Sent Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {detailRows.length > 0 ? detailRows.map((r, i) => (
                                            <tr key={r.FeaIntimationRecipientID}>
                                                <td>{detailFirst + i + 1}</td>
                                                <td>{r.ExhRegistrationNo || '-'}</td>
                                                <td>{r.CompanyName || '-'}</td>
                                                <td>{r.Email || '-'}</td>
                                                <td>{r.RecipientType}</td>
                                                <td>
                                                    <span className={`badge bg-${r.SentStatus === 'Sent' ? 'success' : r.SentStatus === 'Failed' ? 'danger' : 'secondary'}`}>
                                                        {r.SentStatus}
                                                    </span>
                                                </td>
                                                <td style={{ color: '#c0392b', wordBreak: 'break-word', maxWidth: 300 }}>
                                                    {r.ErrorMessage || '-'}
                                                </td>
                                                <td>{r.SentDate ? new Date(r.SentDate).toLocaleString('en-IN', { timeZone: 'UTC', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true }) : '-'}</td>
                                            </tr>
                                        )) : (
                                            <tr><td colSpan="8" className="text-center text-muted py-3">No recipients found.</td></tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            )}

                            {/* Pagination + Close */}
                            <div className="p-2 d-flex justify-content-between align-items-center" style={{ borderTop: '1px solid #dee2e6', flexShrink: 0 }}>
                                <div className="d-flex gap-1 align-items-center" style={{ fontSize: 13 }}>
                                    {detailTab === 'recipients' && (
                                        <>
                                            <button className="btn btn-aqua btn-sm" disabled={detailPage <= 1} onClick={() => this.setState({ detailPage: detailPage - 1 })}>‹ Prev</button>
                                            <span className="px-2 text-muted">Page {detailPage} / {detailPages || 1}</span>
                                            <button className="btn btn-aqua btn-sm" disabled={detailPage >= detailPages} onClick={() => this.setState({ detailPage: detailPage + 1 })}>Next ›</button>
                                        </>
                                    )}
                                </div>
                                <button className="btn btn-gray btn-sm" onClick={() => this.setState({ showDetail: false })}>Close</button>
                            </div>
                        </div>
                    </div>
                )}

                {/* ── Resend Confirmation Modal ── */}
                {showResendConfirm && resendCampaign && (
                    <div style={{
                        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                        backgroundColor: 'rgba(0,0,0,0.65)', zIndex: 100000,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                    }}>
                        <div style={{
                            background: '#fff', borderRadius: 8,
                            width: '90%', maxWidth: 460, overflow: 'hidden',
                        }}>
                            {/* Header */}
                            <div className="p-3 d-flex justify-content-between align-items-center" style={{ background: '#3dbca7' }}>
                                <h5 className="text-white mb-0" style={{ fontSize: 15 }}>Confirm Resend</h5>
                                <button type="button" className="btn-close btn-close-white" onClick={this.closeResendConfirm} />
                            </div>

                            {/* Body */}
                            <div className="p-3" style={{ fontSize: 14 }}>
                                <p className="mb-2">
                                    Resend this email to all <strong>{resendCampaign.RecipientCount || 0}</strong> recipient(s)
                                    of the campaign below?
                                </p>
                                <div className="p-2 mb-2" style={{ background: '#f6f6f6', borderRadius: 4 }}>
                                    <div><strong>Subject:</strong> {resendCampaign.Subject}</div>
                                    <div><strong>Template:</strong> {resendCampaign.TemplateName || '-'}</div>
                                    <div><strong>Already Sent:</strong> {resendCampaign.SentCount || 0} / {resendCampaign.RecipientCount || 0}</div>
                                </div>
                                <small className="text-muted">
                                    Everyone on the list will receive the email again, including those who already got it.
                                </small>
                            </div>

                            {/* Footer */}
                            <div className="p-2 d-flex justify-content-end gap-2" style={{ borderTop: '1px solid #dee2e6' }}>
                                <button className="btn btn-gray btn-sm" onClick={this.closeResendConfirm}>Cancel</button>
                                <button className="btn btn-aqua btn-sm" onClick={this.confirmResend}>Yes, Resend</button>
                            </div>
                        </div>
                    </div>
                )}

                <Footer />
            </>
        );
    }
}

export default withRouter(connect(null, {
    getCampaignList_action,
    sendIntimation_action,
    getCampaignRecipients_action,
})(FeatureIntimationList));
